import { ActionBase } from '..';

const BASE_ACTION = '@auth';

const SET_AUTH = `${BASE_ACTION}/SET_AUTH`;
const setAuth = (payload: boolean): ActionBase => ({ payload, type: SET_AUTH });

export { SET_AUTH, setAuth };
